import { render, staticRenderFns } from "./PageSignUpRegisterExternal.vue?vue&type=template&id=13206d5d"
import script from "./PageSignUpRegisterExternal.vue?vue&type=script&lang=js"
export * from "./PageSignUpRegisterExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports